import { IState } from './state';

export function startLoading(state: IState) {
    state.isLoading = true;
}

export function endLoading(state: IState) {
    state.isLoading = false;
}
